
















import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  InsertFollowPlanDetail,
  UpdateFollowPlanDetail
} from "@/api/follow/followPlan";
@Component({})
export default class FollowPlanDetailAdd extends AbpBase {
  @Prop() data: any;
  model: any = {};
  rules = {
    name: [{ required: true, message: "请输入内容", trigger: "blur" }],
  };

  @Watch("data", { immediate: true })
  onDataChanged() {
    this.model = this.data;
  }

  resetForm() {
    this.$refs.form.resetFields();
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.model.id) {
        await UpdateFollowPlanDetail(this.model);
      } else {
        await InsertFollowPlanDetail(this.model);
      }
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followPlan/planDetailAdd.vue